// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"40466c76","513":"cdd46fb4","703":"3f9d7a2b"}[chunkId] + ".chunk.js";
};